export default __webpack_public_path__ + "static/media/iPhone_distance.3f1fb660.svg";